"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Search = _interopRequireDefault(require("@kyruus/react-ikons/Search"));
var _styles = require("./styles");
var _reactIntl = require("react-intl");
var _utils = require("../../../../lib/utils");
var _message = _interopRequireDefault(require("../../../../lib/message"));
const SearchAltProviderButton = _ref => {
  let {
    clinicalKeyword,
    track
  } = _ref;
  const handleOnClick = () => {
    const newSearchPageUrl = (0, _utils.getBackToSearchPageUrl)(clinicalKeyword);
    window.location.href = newSearchPageUrl;
    track('gx.search_alt_provider_button.clicked', {
      clinical_keyword: clinicalKeyword
    });
  };
  return /*#__PURE__*/_react.default.createElement(_styles.StyledSearchButton, {
    className: "search-alt-btn",
    icon: /*#__PURE__*/_react.default.createElement(_Search.default, {
      "aria-hidden": "true"
    }),
    active: true,
    iconAlign: "left",
    mode: "secondary",
    onClick: handleOnClick,
    "data-testid": "search-alt-provider-button"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, (0, _extends2.default)({}, _message.default.searchForAlternativeProviders, {
    values: {
      clinicalKeyword
    }
  })));
};
SearchAltProviderButton.propTypes = {
  clinicalKeyword: _propTypes.default.string.isRequired,
  track: _propTypes.default.func
};
var _default = exports.default = SearchAltProviderButton;
SearchAltProviderButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchAltProviderButton",
  "props": {
    "clinicalKeyword": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};